import { __assign, __rest } from "tslib";
import * as React from 'react';
import { HideOffScreen } from '../HideOffScreen';
export var OffScreenAnnouncement = function (props) {
    var message = props.message, type = props.type, changeTrigger = props.changeTrigger, other = __rest(props, ["message", "type", "changeTrigger"]);
    var _a = React.useState(undefined), announcedMessage = _a[0], updateMessage = _a[1];
    var updateTimeout = React.useRef();
    React.useEffect(function () {
        var updateFromChangeTrigger = changeTrigger !== undefined && message === announcedMessage;
        var updateFromMessage = message !== announcedMessage;
        if (message && !announcedMessage) {
            updateMessage(message);
        }
        else if (updateFromChangeTrigger || updateFromMessage) {
            updateMessage(undefined);
            updateTimeout.current = setTimeout(function () {
                updateMessage(message);
            });
        }
        return function () {
            if (updateTimeout.current) {
                clearTimeout(updateTimeout.current);
            }
        };
    }, 
    // FIXME in PLAT-1415
    // Adding announcedMessage as a dep causes an infinite render loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [changeTrigger, message]);
    return (React.createElement(HideOffScreen, __assign({ "aria-live": type, role: type === 'polite' ? 'status' : 'alert' }, other), announcedMessage && announcedMessage));
};
OffScreenAnnouncement.defaultProps = {
    type: 'polite',
};
export default OffScreenAnnouncement;
//# sourceMappingURL=OffScreenAnnouncement.js.map